import { TrafficAnalisysRow, EventType, Permission } from '../../modules/traffic-analisys/models';

const filterTicketRows = (rows: TrafficAnalisysRow[]): TrafficAnalisysRow[] => {
  return rows.filter((row) => {
    if (row.eventType === EventType.ENTRY && row.ticketId) {
      return true;
    }
    if (row.eventType === EventType.EXIT) {
      if (row.ticketId) {
        return true;
      }
      return rows.some((r) => r.vehiclePlates === row.vehiclePlates && r.eventType === EventType.ENTRY && Boolean(r.ticketId));
    }
    return false;
  });
};

export const determinePermission = (row: TrafficAnalisysRow, allRows: TrafficAnalisysRow[]): Permission => {
  if (row.blackListEntry) {
    return Permission.BLACK_LIST;
  } else if (row.whiteListEntry) {
    return Permission.WHITE_LIST;
  } else if (row.eventType === EventType.ENTRY) {
    return row.ticketId ? Permission.TICKET : Permission.NONE;
  } else if (row.eventType === EventType.EXIT) {
    if (row.ticketId) {
      return Permission.TICKET;
    }
    const entryWithTicket = allRows.find((r) => r.vehiclePlates === row.vehiclePlates && r.eventType === EventType.ENTRY && Boolean(r.ticketId));
    return entryWithTicket ? Permission.TICKET : Permission.NONE;
  } else {
    return Permission.EMPTY;
  }
};

export const getDisplayedRows = (rows: TrafficAnalisysRow[], selectedPermission: Permission): TrafficAnalisysRow[] => {
  if (selectedPermission === Permission.EMPTY) {
    return rows;
  }
  if (selectedPermission === Permission.TICKET) {
    return filterTicketRows(rows);
  }
  if (selectedPermission === Permission.NONE) {
    return rows.filter((row) => determinePermission(row, rows) === Permission.NONE);
  }
  return rows;
};
